<style src="./style.scss">

</style>

<main id="dnsPage" class="mbsc-grid d-ns-page session-page">
	<nav>
		<MainMenu
			on:menuTapped={togglePages}
		></MainMenu>
	</nav>
  
	{#if router.params.sessionId}
	<SessionDetail
		sessionId={router.params.sessionId}
	></SessionDetail>
	{/if}
	
	<footer class="mbsc-row">
		<nav class="mbsc-col-12">
			<FooterMenu></FooterMenu>
		</nav>
		<CopyrightFooter></CopyrightFooter>
	</footer>
</main>

<script>
import { onMount, afterUpdate } from 'svelte';

import MainMenu from '@Components/MainMenu/index.svelte';

import SessionDetail from '@Pages/Session/content.svelte';

import FooterMenu from '@Components/FooterMenu/index.svelte';
import CopyrightFooter from '@Components/CopyrightFooter/index.svelte';

import { Navigation, Utils, AWSAuth } from '@Services';

const DEBUG = document.location.protocol === 'http:' ? true : false;

export let router = null;

let isVisitor = true;

let togglePages = (event) => {
  Navigation.goTo(event.detail.item);
};

afterUpdate(() => {
	document.body.dispatchEvent(new Event('mbsc-enhance')); 

	Utils.scrollToTop();
});

onMount(async () =>{
	AWSAuth.isAnonymous().then(response => {
    if (response !== isVisitor) {
      isVisitor = response;
    }
	});
	
	if (DEBUG) console.log('App: ' + router.path);
	
	mobiscroll.settings = {
		theme: 'd-ns',
		themeVariant: 'light',
		lang: 'es'
	};

	mobiscroll.page('.session-page', {});

	Utils.scrollToTop();
});
</script>
